/**
 * 3-Step Vinyl Constructor (Disc Cover / Art Disc).
 * Steps: 1 = Cover upload, 2 = Cover text, 3 = Add-ons.
 * Does NOT modify the main product-vinyl.js. Scoped to [data-vinyl-mode="3step"].
 *
 * Ported from the main 7-step constructor: upload flow, crop modal,
 * cover text overlay (draggable/resizable on preview), color pickers,
 * format toolbars, font previews.
 */
(function() {
  'use strict';

  var root = document.querySelector('[data-vinyl-mode="3step"]');
  if (!root) return;

  var config = window.vinylConfig3step || {};
  var FILESTACK_API_KEY = config.filestackApiKey || '';
  var _isShopifyPayments = (config.currencyType === '1' || config.currencyType === 1);
  var _shopCurrency = config.shopCurrency || 'USD';
  var _cartCurrency = config.cartCurrency || _shopCurrency;
  var _isMultiCurrency = (_cartCurrency !== _shopCurrency);
  var ID_SUFFIX = '_3step';
  var COVER_KEYS = ['A', 'A2', 'A3', 'B', 'B2', 'B3', 'B4'];
  var FRONT_KEYS = ['A', 'A2', 'A3'];
  var BACK_KEYS  = ['B', 'B2', 'B3', 'B4'];
  var STORAGE_KEY = 'vinyl_3step_state_' + (config.sectionId || '');

  var state = {
    currentStep: 1,
    uploadedFiles: {},
    coverText: {
      A:  { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#FFFFFF', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 15, w: 50 },
      A2: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#FFFFFF', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 45, w: 50 },
      A3: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#FFFFFF', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 75, w: 50 },
      B:  { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#FFFFFF', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 35, w: 50 },
      B2: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#FFFFFF', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 53, w: 50 },
      B3: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#FFFFFF', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 70, w: 50 },
      B4: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#FFFFFF', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 85, w: 50 }
    },
    addonsTotal: 0,
    basePrice: config.basePrice || 0,
    discountRatio: config.discountRatio || 0.28,
    quantity: 1,
    customizationComplete: false,
    cropper: null,
    cropTargetIndex: null
  };

  function sid(elId) { return document.getElementById(elId + ID_SUFFIX) || document.getElementById(elId); }
  function q(sel) { return root.querySelector(sel); }
  function qAll(sel) { return root.querySelectorAll(sel); }

  var dom = {
    accordion: q('.vinyl-accordion'),
    form: q('form'),
    submitBtn: q('[type="submit"]'),
    shopPayBtn: q('.vinyl-btn--shop-pay'),
    quantityInput: document.getElementById('vinyl-quantity-input-3step'),
    cropModal: document.getElementById('vinylCropModal'),
    cropImage: document.getElementById('vinyl-crop-image'),
    cropConfirm: document.getElementById('vinyl-crop-confirm'),
    cropCancel: document.getElementById('vinyl-crop-cancel'),
    previewThumbs: root.querySelectorAll('.vinyl-preview__thumb'),
    previewSlides: root.querySelectorAll('.vinyl-preview__slide')
  };

  /* ==========================================================================
     HIDE SIDE A / SIDE B THUMBS — keep FRONT, BACK, ALL
     ========================================================================== */
  (function hideExtraThumbs() {
    root.querySelectorAll('.vinyl-preview__thumb').forEach(function(thumb) {
      var target = thumb.dataset.target;
      if (target === 'vinyl-a' || target === 'vinyl-b') thumb.style.display = 'none';
    });
    root.querySelectorAll('.vinyl-preview__slide').forEach(function(slide) {
      var ds = slide.dataset.slide;
      if (ds === 'vinyl-a' || ds === 'vinyl-b') slide.style.display = 'none';
    });
  })();

  /* ==========================================================================
     PREVIEW SLIDE NAVIGATION
     ========================================================================== */
  function activatePreviewSlide(slideId) {
    dom.previewThumbs.forEach(function(t) { t.classList.remove('vinyl-preview__thumb--active'); });
    dom.previewSlides.forEach(function(s) { s.classList.remove('vinyl-preview__slide--active'); });
    var preview = root.querySelector('.vinyl-preview__slides');
    if (preview) {
      preview.classList.remove('vinyl-preview__slides--hero');
      preview.classList.toggle('vinyl-preview__slides--fullset', slideId === 'full-set');
    }
    var slide = root.querySelector('.vinyl-preview__slide[data-slide="' + slideId + '"]');
    var thumb = root.querySelector('.vinyl-preview__thumb[data-target="' + slideId + '"]');
    if (slide) slide.classList.add('vinyl-preview__slide--active');
    if (thumb) thumb.classList.add('vinyl-preview__thumb--active');
    if (slideId === 'full-set') refreshFullSetTextOverlays();
  }

  function refreshFullSetTextOverlays() {
    COVER_KEYS.forEach(function(key) { updateCoverTextPreview(key); });
  }

  function bindPreviewThumbs() {
    dom.previewThumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var target = thumb.dataset.target;
        if (target) activatePreviewSlide(target);
      });
    });
  }

  /* ==========================================================================
     STATE PERSISTENCE
     ========================================================================== */
  function saveState() {
    try {
      var snap = { coverText: state.coverText, quantity: state.quantity, uploadedFiles: {} };
      [1, 2].forEach(function(i) {
        var f = state.uploadedFiles[i];
        if (f) snap.uploadedFiles[i] = { name: f.name, resolution: f.resolution, fileUrl: f.fileUrl || f.previewUrl, previewUrl: f.previewUrl || f.fileUrl };
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snap));
    } catch (e) {}
  }

  function restoreState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var snap = JSON.parse(raw);
      if (snap.coverText) {
        COVER_KEYS.forEach(function(k) {
          if (snap.coverText[k]) state.coverText[k] = Object.assign({}, state.coverText[k], snap.coverText[k]);
        });
      }
      if (snap.quantity) state.quantity = snap.quantity;
      if (dom.quantityInput) dom.quantityInput.value = state.quantity;
      if (snap.uploadedFiles) {
        Object.keys(snap.uploadedFiles).forEach(function(k) {
          var f = snap.uploadedFiles[k];
          if (f && f.previewUrl) showUploadedFile(parseInt(k, 10), f.name || 'image', f.resolution || '', f.previewUrl, f.fileUrl || f.previewUrl, 0, 0);
        });
      }
      COVER_KEYS.forEach(function(k) {
        var d = state.coverText[k]; if (!d) return;
        var ti = sid('coverText' + k);
        var fs = sid('coverFont' + k);
        var ss = sid('coverSize' + k);
        var lh = sid('coverLineHeight' + k);
        var ci = sid('coverColor' + k);
        var cp = sid('coverColorPreview' + k);
        var wr = sid('coverWidth' + k);
        var wv = sid('coverWidthVal' + k);
        if (ti) ti.value = d.text || '';
        if (fs) fs.value = d.font || 'Roboto';
        if (ss) ss.value = d.size || '24';
        if (lh) lh.value = d.lineHeight || '1.2';
        if (ci) ci.value = d.color || '#FFFFFF';
        if (cp) cp.style.background = d.color || '#FFFFFF';
        if (wr) wr.value = d.w || 50;
        if (wv) wv.textContent = (d.w || 50) + '%';
        if (d.text) updateCoverTextPreview(k);
      });
      return true;
    } catch (e) { return false; }
  }

  /* ==========================================================================
     CUSTOMIZATION STATUS
     ========================================================================== */
  function checkCustomizationStatus() {
    state.customizationComplete = !!state.uploadedFiles[1] && !!state.uploadedFiles[2];
    if (dom.submitBtn) {
      dom.submitBtn.disabled = !state.customizationComplete;
      dom.submitBtn.classList.toggle('vinyl-btn--customization', !state.customizationComplete);
    }
    if (dom.shopPayBtn) {
      dom.shopPayBtn.disabled = !state.customizationComplete;
      dom.shopPayBtn.classList.toggle('vinyl-btn--customization', !state.customizationComplete);
    }
    updateAddonsTotal();
    updateStepCheckmarks();
    saveState();
  }

  function updateStepCheckmarks() {
    var step1El = root.querySelector('[data-step="1"]');
    var step2El = root.querySelector('[data-step="2"]');
    var step3El = root.querySelector('[data-step="3"]');

    var step1Done = !!state.uploadedFiles[1] && !!state.uploadedFiles[2];
    var step2Done = !!(state.coverText.A.text || state.coverText.A2.text || state.coverText.A3.text ||
                       state.coverText.B.text || state.coverText.B2.text || state.coverText.B3.text || state.coverText.B4.text);
    var step3Done = !!root.querySelector('.vinyl-addon input[type="checkbox"]:checked');

    if (step1El) step1El.classList.toggle('vinyl-step--checked', step1Done);
    if (step2El) step2El.classList.toggle('vinyl-step--checked', step2Done);
    if (step3El) step3El.classList.toggle('vinyl-step--checked', step3Done);

    var thumb1 = root.querySelector('.vinyl-preview__thumb[data-upload-index="1"]');
    var thumb2 = root.querySelector('.vinyl-preview__thumb[data-upload-index="2"]');
    if (thumb1) { var c1 = thumb1.querySelector('.vinyl-preview__thumb-check'); if (c1) c1.style.display = state.uploadedFiles[1] ? '' : 'none'; }
    if (thumb2) { var c2 = thumb2.querySelector('.vinyl-preview__thumb-check'); if (c2) c2.style.display = state.uploadedFiles[2] ? '' : 'none'; }

    var allThumb = root.querySelector('.vinyl-preview__thumb[data-upload-index="0"]');
    if (allThumb) {
      var allDone = !!state.uploadedFiles[1] && !!state.uploadedFiles[2];
      var allCheck = allThumb.querySelector('.vinyl-preview__thumb-check');
      if (allCheck) allCheck.style.display = allDone ? '' : 'none';
    }
  }

  function updateAddonsTotal() {
    var total = 0;
    qAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) { total += parseFloat(cb.dataset.value || 0); });
    state.addonsTotal = total;
    updatePriceDisplay();
  }

  /* ==========================================================================
     DYNAMIC PRICING (ported from main constructor)
     ========================================================================== */
  function getCurrencyRate() {
    try { return parseFloat(Shopify.currency.rate) || 1; } catch(e) { return 1; }
  }

  function formatMoney(cents) {
    var symbol = config.currencySymbol || '$';
    var raw = (Math.abs(cents) / 100).toFixed(2);
    var amount = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return cents < 0 ? ('-' + symbol + amount) : (symbol + amount);
  }

  function formatMoneyTheme(cents) {
    var fmt = config.moneyFormat || ('$' + '{{amount}}');
    var absVal = Math.abs(cents);
    var dollars = (absVal / 100).toFixed(2);
    var formatted = dollars.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    var result = fmt.replace(/\{\{\s*amount\s*\}\}/, formatted)
                    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(absVal / 100).toString())
                    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dollars.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
                    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(absVal / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'));
    return cents < 0 ? '-' + result : result;
  }

  function updatePriceDisplay() {
    var rate = getCurrencyRate();
    var addonsCentsUSD = Math.round(state.addonsTotal * 100);
    var addonsCents, baseCents;

    if (_isShopifyPayments && _isMultiCurrency) {
      baseCents = state.basePrice;
      addonsCents = Math.round(addonsCentsUSD * rate);
    } else {
      baseCents = state.basePrice;
      addonsCents = addonsCentsUSD;
    }

    var totalPerItem = baseCents + addonsCents;

    var discount = 0;
    if (state.quantity >= 6) discount = 0.15;
    else if (state.quantity >= 3) discount = 0.10;

    var discountedPerItem = Math.round(totalPerItem * (1 - discount));
    var totalPrice = discountedPerItem * state.quantity;

    var baseCompareCents = state.discountRatio > 0
      ? Math.round(baseCents / (1 - state.discountRatio))
      : 0;
    var compareTotalPerItem = baseCompareCents > 0
      ? baseCompareCents + addonsCents
      : 0;

    var savings = compareTotalPerItem > discountedPerItem ? compareTotalPerItem - discountedPerItem : 0;

    var priceEl = root.querySelector('.vinyl-price__current .money');
    var compareWrapper = root.querySelector('.vinyl-price__compare');
    var compareEl = compareWrapper ? compareWrapper.querySelector('.money') : null;
    var savingsAmountEl = root.querySelector('.vinyl-savings__amount .money');
    var savingsTotalEl = root.querySelector('.vinyl-savings__total .money') || root.querySelector('.vinyl-savings__total');
    var discountPctEl = root.querySelector('.vinyl-discount-percent');
    var badgeEl = root.querySelector('.vinyl-price__badge');

    var useThemeFormat = (_isShopifyPayments && _isMultiCurrency);
    var fmtFn = useThemeFormat ? formatMoneyTheme : formatMoney;

    if (priceEl) {
      priceEl.innerHTML = fmtFn(discountedPerItem);
      if (!useThemeFormat) priceEl.dataset.basecut4s = discountedPerItem;
    }

    if (compareWrapper) {
      if (savings > 0 && compareEl) {
        compareEl.innerHTML = fmtFn(compareTotalPerItem);
        if (!useThemeFormat) compareEl.dataset.basecut4s = compareTotalPerItem;
        compareWrapper.classList.remove('visually-hidden');
      } else {
        compareWrapper.classList.add('visually-hidden');
      }
    }

    if (savingsAmountEl) {
      savingsAmountEl.innerHTML = fmtFn(savings);
      if (!useThemeFormat) savingsAmountEl.dataset.basecut4s = savings;
    }
    if (savingsTotalEl) {
      savingsTotalEl.innerHTML = fmtFn(totalPrice);
      if (!useThemeFormat) savingsTotalEl.dataset.basecut4s = totalPrice;
    }

    if (badgeEl) {
      if (savings > 0 && compareTotalPerItem > 0) {
        var pct = Math.round(savings / compareTotalPerItem * 100);
        if (discountPctEl) discountPctEl.textContent = pct + '%';
        badgeEl.classList.remove('visually-hidden');
      } else {
        badgeEl.classList.add('visually-hidden');
      }
    }

    updateAddonLabels();

    if (!useThemeFormat) {
      triggerCurrencyConverter();
    }
  }

  function updateAddonLabels() {
    var useThemeFormat = (_isShopifyPayments && _isMultiCurrency);
    var rate = getCurrencyRate();
    var activeCurr = 'USD';
    try { activeCurr = Shopify.currency.active || 'USD'; } catch(e) {}

    root.querySelectorAll('.vinyl-addon__price span.money').forEach(function(el) {
      var priceUSD = parseFloat(el.getAttribute('data-addon-price')) || 0;
      if (useThemeFormat) {
        var centsLocal = Math.round(priceUSD * 100 * rate);
        el.innerHTML = formatMoneyTheme(centsLocal);
      } else if (activeCurr !== 'USD' && rate !== 1) {
        var centsLocal = Math.round(priceUSD * 100 * rate);
        var converted = (centsLocal / 100).toFixed(2);
        el.textContent = (config.currencySymbol || '$') + converted;
        delete el.dataset.basecut4s;
      } else {
        el.textContent = '$' + priceUSD.toFixed(2);
        el.dataset.basecut4s = Math.round(priceUSD * 100);
      }
    });
  }

  function triggerCurrencyConverter() {
    try {
      window._vinylCurrencyUpdating = true;
      if (typeof jQuery_T4NT !== 'undefined') {
        jQuery_T4NT('body').trigger('currency:update');
      } else if (typeof jQuery !== 'undefined') {
        jQuery('body').trigger('currency:update');
      } else {
        document.body.dispatchEvent(new CustomEvent('currency:update'));
      }
      setTimeout(function() { window._vinylCurrencyUpdating = false; }, 0);
    } catch(e) {
      window._vinylCurrencyUpdating = false;
    }
  }

  /* ==========================================================================
     FILE UPLOAD — show / update / delete
     ========================================================================== */
  function showUploadedFile(index, fileName, resolution, previewUrl, fileUrl, origW, origH) {
    var fileEl = q('.vinyl-uploaded-file[data-index="' + index + '"]');
    var uploader = q('.vinyl-uploader[data-index="' + index + '"]');
    if (!fileEl) return;
    fileEl.classList.remove('visually-hidden');
    if (uploader) uploader.style.display = 'none';
    var previewImg = fileEl.querySelector('.preview_img');
    if (previewImg) previewImg.src = previewUrl;
    state.uploadedFiles[index] = { name: fileName, resolution: resolution, previewUrl: previewUrl, fileUrl: fileUrl || previewUrl, blob: null };
    if (previewUrl && previewUrl.indexOf('data:') === 0) {
      fetch(previewUrl).then(function(r) { return r.blob(); }).then(function(blob) {
        state.uploadedFiles[index].blob = new File([blob], fileName, { type: 'image/jpeg' });
      });
    }
    updatePreview(index, previewUrl);
    var slideMap = { 1: 'front-cover', 2: 'back-cover' };
    if (slideMap[index]) activatePreviewSlide(slideMap[index]);
    updateDpiBadge(index, origW || 0, origH || 0);
    checkCustomizationStatus();
    saveState();
  }

  function updateDpiBadge(index, width, height) {
    var badge = q('.vinyl-dpi-badge[data-index="' + index + '"]');
    if (!badge || !width || !height) return;
    var printSize = 13;
    var dpi = parseInt(width / printSize, 10);
    var tierClass, tierLabel;
    if (dpi > 300) { tierClass = 'vinyl-dpi-badge--high'; tierLabel = 'High quality'; }
    else if (dpi > 150) { tierClass = 'vinyl-dpi-badge--good'; tierLabel = 'Good quality'; }
    else { tierClass = 'vinyl-dpi-badge--low'; tierLabel = 'Low quality'; }
    badge.className = 'vinyl-dpi-badge ' + tierClass;
    badge.textContent = tierLabel + ' Print (' + dpi + ' DPI)';
  }

  function updatePreview(index, imageUrl) {
    var map = index === 1
      ? { slide: 'front-cover', sel: '.vinyl-preview__cover--front .vinyl-preview__image' }
      : index === 2
        ? { slide: 'back-cover', sel: '.vinyl-preview__cover--back .vinyl-preview__image' }
        : null;
    if (!map) return;
    qAll(map.sel).forEach(function(img) { img.src = imageUrl || ''; img.style.display = imageUrl ? 'block' : 'none'; });
    qAll('.vinyl-preview__slide[data-slide="' + map.slide + '"] .vinyl-preview__placeholder').forEach(function(ph) { ph.style.display = imageUrl ? 'none' : ''; });
    var coverEl = q('.vinyl-preview__slide[data-slide="' + map.slide + '"] .vinyl-preview__cover');
    if (coverEl) coverEl.classList.toggle('vinyl-preview__cover--has-image', !!imageUrl);
    var thumb = q('.vinyl-preview__thumb[data-upload-index="' + index + '"]');
    if (thumb) {
      var thumbImg = thumb.querySelector('.vinyl-preview__thumb-img');
      var thumbIcon = thumb.querySelector('.vinyl-preview__thumb-icon');
      if (thumbImg && thumbIcon) {
        thumbImg.src = imageUrl || '';
        thumbImg.style.display = imageUrl ? '' : 'none';
        thumbIcon.style.display = imageUrl ? 'none' : '';
      }
    }
    updateFullSetGrid(index, imageUrl);
    updateAllThumb();
  }

  function updateFullSetGrid(index, imageUrl) {
    var fullKey = index === 1 ? 'front' : index === 2 ? 'back' : null;
    if (!fullKey) return;
    var fullCell = root.querySelector('.vinyl-preview__full-cell[data-full="' + fullKey + '"]');
    if (!fullCell) return;
    var fImg = fullCell.querySelector('.vinyl-preview__full-img');
    var fPh = fullCell.querySelector('.vinyl-preview__placeholder');
    if (fImg) { fImg.src = imageUrl || ''; fImg.style.display = imageUrl ? 'block' : 'none'; }
    if (fPh) fPh.style.display = imageUrl ? 'none' : '';
  }

  function updateAllThumb() {
    var allThumb = root.querySelector('.vinyl-preview__thumb[data-upload-index="0"]');
    if (!allThumb) return;
    var thumbImg = allThumb.querySelector('.vinyl-preview__thumb-img');
    var thumbIcon = allThumb.querySelector('.vinyl-preview__thumb-icon');
    if (!thumbImg || !thumbIcon) return;
    var firstUrl = '';
    for (var i = 1; i <= 2; i++) {
      if (state.uploadedFiles[i] && (state.uploadedFiles[i].previewUrl || state.uploadedFiles[i].fileUrl)) {
        firstUrl = state.uploadedFiles[i].previewUrl || state.uploadedFiles[i].fileUrl;
        break;
      }
    }
    if (firstUrl) { thumbImg.src = firstUrl; thumbImg.style.display = ''; thumbIcon.style.display = 'none'; }
    else { thumbImg.src = ''; thumbImg.style.display = 'none'; thumbIcon.style.display = ''; }
  }

  function deleteUploadedFile(index) {
    var fileEl = q('.vinyl-uploaded-file[data-index="' + index + '"]');
    var uploader = q('.vinyl-uploader[data-index="' + index + '"]');
    if (fileEl) fileEl.classList.add('visually-hidden');
    if (uploader) uploader.style.display = '';
    delete state.uploadedFiles[index];
    updatePreview(index, null);
    checkCustomizationStatus();
  }

  /* ==========================================================================
     CROP MODAL
     ========================================================================== */
  function openCropModal(imageSource, index) {
    if (!dom.cropModal || !dom.cropImage) return;
    state.cropTargetIndex = index;
    if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
    dom.cropImage.onload = null;
    dom.cropImage.src = '';
    function initCropper() {
      if (typeof Cropper === 'undefined') { setTimeout(initCropper, 300); return; }
      if (!dom.cropImage.complete || dom.cropImage.naturalWidth === 0) { setTimeout(initCropper, 200); return; }
      if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
      dom.cropImage.style.opacity = '1';
      state.cropper = new Cropper(dom.cropImage, {
        aspectRatio: 1, viewMode: 2, autoCrop: true, autoCropArea: 1,
        movable: true, zoomable: true, scalable: true, rotatable: true,
        responsive: true, background: true, guides: true, center: true,
        highlight: true, cropBoxMovable: true, cropBoxResizable: true,
        dragMode: 'move', minContainerWidth: 200, minContainerHeight: 200
      });
    }
    dom.cropImage.onload = initCropper;
    dom.cropImage.onerror = function() { console.error('[Vinyl3] Failed to load crop image'); };
    if (typeof imageSource === 'string') dom.cropImage.src = imageSource;
    else dom.cropImage.src = URL.createObjectURL(imageSource);
    dom.cropModal.style.display = 'flex';
    setTimeout(initCropper, 500);
    setTimeout(initCropper, 1500);
  }

  function handleCropConfirm() {
    var index = state.cropTargetIndex;
    if (state.cropper) {
      var cropData = state.cropper.getData();
      var origCropW = Math.round(cropData.width);
      var origCropH = Math.round(cropData.height);
      var canvas = state.cropper.getCroppedCanvas({ width: origCropW, height: origCropH, imageSmoothingQuality: 'high' });
      if (canvas) {
        var dataUrl = canvas.toDataURL('image/jpeg', 0.92);
        uploadToFilestack(dataUrl, index, canvas.width, canvas.height, origCropW, origCropH);
      }
    } else {
      closeCropModal();
    }
  }

  function uploadToFilestack(dataUrl, index, width, height, origW, origH) {
    var animation = dom.cropModal ? dom.cropModal.querySelector('.vinyl-crop-modal__upload-animation') : null;
    var actions = dom.cropModal ? dom.cropModal.querySelector('.vinyl-crop-modal__actions') : null;

    if (animation) animation.style.display = 'block';
    if (actions) actions.style.display = 'none';

    if (FILESTACK_API_KEY) {
      fetch(dataUrl)
        .then(function(res) { return res.blob(); })
        .then(function(blob) {
          var formData = new FormData();
          formData.append('fileUpload', blob, 'vinyl_image_' + index + '.jpg');
          return fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK_API_KEY, {
            method: 'POST',
            body: formData
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var fileUrl = data.url || dataUrl;
          finalizeCrop(index, fileUrl, dataUrl, width, height, origW, origH);
        })
        .catch(function() {
          finalizeCrop(index, dataUrl, dataUrl, width, height, origW, origH);
        });
    } else {
      setTimeout(function() {
        finalizeCrop(index, dataUrl, dataUrl, width, height, origW, origH);
      }, 300);
    }
  }

  function finalizeCrop(index, fileUrl, previewUrl, width, height, origW, origH) {
    var fileName = 'vinyl_image_' + index + '.jpg';
    var resolution = width + ' x ' + height + 'px';
    showUploadedFile(index, fileName, resolution, previewUrl, fileUrl, origW || width, origH || height);
    closeCropModal();
  }

  function closeCropModal() {
    if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
    if (dom.cropModal) {
      dom.cropModal.style.display = 'none';
      var animation = dom.cropModal.querySelector('.vinyl-crop-modal__upload-animation');
      var actions = dom.cropModal.querySelector('.vinyl-crop-modal__actions');
      if (animation) animation.style.display = 'none';
      if (actions) actions.style.display = '';
    }
    state.cropTargetIndex = null;
  }

  function bindCropModal() {
    if (dom.cropConfirm) dom.cropConfirm.addEventListener('click', handleCropConfirm);
    if (dom.cropCancel) dom.cropCancel.addEventListener('click', closeCropModal);
  }

  /* ==========================================================================
     UPLOAD MODAL — Fixed: no double file-picker
     ========================================================================== */
  function showConvertingState(index, show) {
    var uploader = q('.vinyl-uploader[data-index="' + index + '"]');
    if (!uploader) return;
    var converting = uploader.querySelector('.vinyl-dropzone-modal__converting');
    if (converting) converting.style.display = show ? 'flex' : 'none';
  }

  function openUploadModal(uploader, index) {
    var modalWrapper = uploader.querySelector('.vinyl-upload-modal-wrapper');
    if (!modalWrapper) return;
    modalWrapper.classList.add('active');
    var dropArea = modalWrapper.querySelector('.vinyl-dropzone-modal__area');
    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg,image/png,image/webp,application/pdf,image/tiff,.heic';
    fileInput.style.display = 'none';

    function handleFile(file) {
      modalWrapper.classList.remove('active');
      if (file.name.toLowerCase().endsWith('.heic')) {
        showConvertingState(index, true);
        if (typeof heic2any !== 'undefined') {
          heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 })
            .then(function(blob) { showConvertingState(index, false); openCropModal(blob, index); })
            .catch(function() { showConvertingState(index, false); openCropModal(file, index); });
        } else { showConvertingState(index, false); openCropModal(file, index); }
      } else {
        var reader = new FileReader();
        reader.onload = function(e) { openCropModal(e.target.result, index); };
        reader.readAsDataURL(file);
      }
      fileInput.remove();
    }

    fileInput.addEventListener('change', function(e) { if (e.target.files.length) handleFile(e.target.files[0]); });

    if (dropArea) {
      var clickHandler = function(e) {
        e.stopPropagation();
        fileInput.click();
      };
      dropArea.addEventListener('click', clickHandler, { once: true });
      dropArea.addEventListener('dragover', function(e) { e.preventDefault(); dropArea.classList.add('dragover'); });
      dropArea.addEventListener('dragleave', function() { dropArea.classList.remove('dragover'); });
      dropArea.addEventListener('drop', function(e) { e.preventDefault(); dropArea.classList.remove('dragover'); if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]); });
    }

    document.body.appendChild(fileInput);
  }

  function bindUploaders() {
    qAll('.vinyl-uploader').forEach(function(uploader) {
      var index = parseInt(uploader.dataset.index, 10);
      if (index !== 1 && index !== 2) return;

      var modalWrapper = uploader.querySelector('.vinyl-upload-modal-wrapper');
      var closeBtn = modalWrapper ? modalWrapper.querySelector('.vinyl-dropzone-modal__close') : null;
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); if (modalWrapper) modalWrapper.classList.remove('active'); });
      }
      if (modalWrapper) {
        modalWrapper.addEventListener('click', function(e) { if (e.target === modalWrapper) modalWrapper.classList.remove('active'); });
      }

      var defaultLabel = uploader.querySelector('.vinyl-uploader__default');
      if (defaultLabel) {
        defaultLabel.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openUploadModal(uploader, index);
        });
      }
    });

    qAll('.vinyl-uploaded-file__delete').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var fileEl = btn.closest('.vinyl-uploaded-file');
        if (fileEl) deleteUploadedFile(parseInt(fileEl.dataset.index, 10));
      });
    });
    qAll('.vinyl-uploaded-file__edit').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var fileEl = btn.closest('.vinyl-uploaded-file');
        if (!fileEl) return;
        var idx = parseInt(fileEl.dataset.index, 10);
        var up = q('.vinyl-uploader[data-index="' + idx + '"]');
        if (up) {
          var wasHidden = up.style.display === 'none';
          if (wasHidden) up.style.display = '';
          openUploadModal(up, idx);
          if (wasHidden) {
            var mw = up.querySelector('.vinyl-upload-modal-wrapper');
            if (mw) {
              var obs = new MutationObserver(function() {
                if (!mw.classList.contains('active')) { up.style.display = 'none'; obs.disconnect(); }
              });
              obs.observe(mw, { attributes: true, attributeFilter: ['class'] });
            }
          }
        }
      });
    });
  }

  /* ==========================================================================
     COVER TEXT PREVIEW OVERLAY (ported from main constructor)
     ========================================================================== */
  function updateCoverTextPreview(side) {
    var overlayKey = 'cover-' + side;
    var overlay = root.querySelector('[data-text-overlay="' + overlayKey + '"]');
    var gridOverlay = root.querySelector('[data-text-overlay-grid="' + overlayKey + '"]');
    var data = state.coverText[side];
    if (!data) return;

    if (!data.text) {
      if (overlay) {
        overlay.style.display = 'none';
        var ts = overlay.querySelector('.vinyl-overlay__text');
        if (ts) { ts.textContent = ''; ts.style.textDecoration = 'none'; ts.style.fontWeight = 'normal'; ts.style.fontStyle = 'normal'; }
      }
      if (gridOverlay) { gridOverlay.style.display = 'none'; gridOverlay.textContent = ''; }
      return;
    }

    var fontFamily = '"' + data.font + '", sans-serif';
    var fontWeight = data.bold ? 'bold' : 'normal';
    var fontStyle = data.italic ? 'italic' : 'normal';
    var textDecor = data.underline ? 'underline' : 'none';
    var lineHeight = data.lineHeight || '1.2';

    if (overlay) {
      var textSpan = overlay.querySelector('.vinyl-overlay__text');
      if (textSpan) {
        textSpan.textContent = data.text;
        textSpan.style.textDecoration = textDecor;
        textSpan.style.fontWeight = fontWeight;
        textSpan.style.fontStyle = fontStyle;
      }
      overlay.style.fontFamily = fontFamily;
      overlay.style.color = data.color;
      var basePx = parseInt(data.size, 10) || 24;
      var scaledPx = Math.max(12, Math.min(36, Math.round(basePx * 0.45)));
      overlay.style.fontSize = scaledPx + 'px';
      overlay.style.lineHeight = lineHeight;
      overlay.style.fontWeight = fontWeight;
      overlay.style.fontStyle = fontStyle;
      overlay.style.textDecoration = 'none';
      overlay.style.overflow = 'visible';
      var zMap = { A: 5, A2: 6, A3: 7, B: 5, B2: 6, B3: 7, B4: 8 };
      overlay.style.zIndex = zMap[side] || 5;
      overlay.style.display = 'block';
      overlay.style.position = 'absolute';
      overlay.style.inset = 'auto';
      overlay.style.left = (data.x || 50) + '%';
      overlay.style.top = (data.y || 50) + '%';
      overlay.style.width = (data.w || 50) + '%';
      overlay.style.transform = 'translate(-50%, -50%)';
    }

    if (gridOverlay) {
      gridOverlay.textContent = data.text;
      gridOverlay.style.display = 'block';
      gridOverlay.style.fontFamily = fontFamily;
      gridOverlay.style.color = data.color;
      var gridPx = parseInt(data.size, 10) || 24;
      var gridScaled = Math.max(7, Math.round(gridPx * 0.22));
      gridOverlay.style.fontSize = gridScaled + 'px';
      gridOverlay.style.lineHeight = lineHeight;
      gridOverlay.style.fontWeight = fontWeight;
      gridOverlay.style.fontStyle = fontStyle;
      gridOverlay.style.textDecoration = textDecor;
      gridOverlay.style.overflow = 'visible';
      gridOverlay.style.position = 'absolute';
      gridOverlay.style.inset = 'auto';
      gridOverlay.style.left = (data.x || 50) + '%';
      gridOverlay.style.top = (data.y || 50) + '%';
      gridOverlay.style.transform = 'translate(-50%, -50%)';
      gridOverlay.style.width = (data.w || 50) + '%';
    }

    saveState();
  }

  function refreshSiblingPreviews(side) {
    var prefix = side.charAt(0);
    COVER_KEYS.forEach(function(k) {
      if (k !== side && k.charAt(0) === prefix && state.coverText[k] && state.coverText[k].text) updateCoverTextPreview(k);
    });
  }

  function syncGridOverlay(key) {
    var gridOverlay = root.querySelector('[data-text-overlay-grid="cover-' + key + '"]');
    if (!gridOverlay || !state.coverText[key]) return;
    var data = state.coverText[key];
    gridOverlay.style.left = (data.x || 50) + '%';
    gridOverlay.style.top = (data.y || 50) + '%';
    gridOverlay.style.width = (data.w || 50) + '%';
  }

  /* ==========================================================================
     DRAG-AND-DROP OVERLAYS (ported from main constructor)
     ========================================================================== */
  function getPointerPos(e) {
    if (e.touches && e.touches.length) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    return { x: e.clientX, y: e.clientY };
  }

  function makeDraggable(el, fieldKey) {
    var isDragging = false;
    var startX, startY, elStartX, elStartY;
    function onDown(e) {
      if (e.target.closest('.vinyl-overlay__resize')) return;
      if (!state.coverText[fieldKey] || !state.coverText[fieldKey].text) return;
      isDragging = true;
      var pos = getPointerPos(e);
      startX = pos.x; startY = pos.y;
      var parent = el.parentElement;
      var rect = parent.getBoundingClientRect();
      elStartX = (parseFloat(el.style.left) || 50) / 100 * rect.width;
      elStartY = (parseFloat(el.style.top) || 50) / 100 * rect.height;
      el.classList.add('dragging');
      e.preventDefault();
    }
    function onMove(e) {
      if (!isDragging) return;
      var pos = getPointerPos(e);
      var parent = el.parentElement;
      var rect = parent.getBoundingClientRect();
      var padX = rect.width * 0.05, padY = rect.height * 0.05;
      var newX = Math.max(padX, Math.min(rect.width - padX, elStartX + pos.x - startX));
      var newY = Math.max(padY, Math.min(rect.height - padY, elStartY + pos.y - startY));
      el.style.left = (newX / rect.width * 100) + '%';
      el.style.top = (newY / rect.height * 100) + '%';
    }
    function onUp() {
      if (!isDragging) return;
      isDragging = false;
      el.classList.remove('dragging');
      state.coverText[fieldKey].x = Math.round((parseFloat(el.style.left) || 50) * 10) / 10;
      state.coverText[fieldKey].y = Math.round((parseFloat(el.style.top) || 50) * 10) / 10;
      syncGridOverlay(fieldKey);
      saveState();
    }
    el.addEventListener('mousedown', onDown);
    el.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);
  }

  function makeResizable(overlay, fieldKey) {
    var handles = overlay.querySelectorAll('.vinyl-overlay__resize');
    if (!handles.length) return;
    var isResizing = false, startX, startW, dir;
    handles.forEach(function(handle) {
      function onDown(e) {
        isResizing = true;
        dir = parseInt(handle.dataset.resizeDir, 10) || 1;
        var pos = getPointerPos(e);
        startX = pos.x;
        startW = (state.coverText[fieldKey].w || 50) / 100 * overlay.parentElement.getBoundingClientRect().width;
        overlay.classList.add('resizing');
        e.preventDefault(); e.stopPropagation();
      }
      handle.addEventListener('mousedown', onDown);
      handle.addEventListener('touchstart', onDown, { passive: false });
    });
    function onMove(e) {
      if (!isResizing) return;
      var pos = getPointerPos(e);
      var parentW = overlay.parentElement.getBoundingClientRect().width;
      var newW = Math.max(parentW * 0.15, Math.min(parentW, startW + (pos.x - startX) * dir));
      overlay.style.width = (newW / parentW * 100) + '%';
    }
    function onUp() {
      if (!isResizing) return;
      isResizing = false;
      overlay.classList.remove('resizing');
      var w = Math.round(parseFloat(overlay.style.width) || 50);
      state.coverText[fieldKey].w = w;
      var wr = sid('coverWidth' + fieldKey);
      var wv = sid('coverWidthVal' + fieldKey);
      if (wr) wr.value = w;
      if (wv) wv.textContent = w + '%';
      syncGridOverlay(fieldKey);
      saveState();
    }
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);
  }

  function initDraggableOverlays() {
    COVER_KEYS.forEach(function(key) {
      var overlay = root.querySelector('[data-text-overlay="cover-' + key + '"]');
      if (!overlay) return;
      makeDraggable(overlay, key);
      makeResizable(overlay, key);
    });
  }

  /* ==========================================================================
     GOOGLE FONTS — preload & preview
     ========================================================================== */
  function preloadFont(fontFamily, bold, italic) {
    var weight = bold ? '700' : '400';
    var style = italic ? 'italic' : 'normal';
    if (document.fonts && document.fonts.load) {
      document.fonts.load(style + ' ' + weight + ' 16px "' + fontFamily + '"').catch(function() {});
    }
  }

  function applyFontPreviews() {
    root.querySelectorAll('.vinyl-font-select').forEach(function(select) {
      Array.from(select.options).forEach(function(opt) { opt.style.fontFamily = '"' + opt.value + '", sans-serif'; });
      select.style.fontFamily = '"' + select.value + '", sans-serif';
      select.addEventListener('change', function() { select.style.fontFamily = '"' + select.value + '", sans-serif'; });
    });
  }

  /* ==========================================================================
     COVER TEXT UI (ported from main constructor)
     ========================================================================== */
  function bindCoverTextUI() {
    var tabs = root.querySelectorAll('[data-cover-side]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var side = tab.dataset.coverSide;
        tabs.forEach(function(t) { t.classList.remove('vinyl-text-tab--active'); });
        tab.classList.add('vinyl-text-tab--active');
        root.querySelectorAll('.vinyl-cover-text-panel').forEach(function(p) {
          p.style.display = p.dataset.coverPanel === side ? '' : 'none';
        });
        activatePreviewSlide(side === 'A' ? 'front-cover' : 'back-cover');
      });
    });

    COVER_KEYS.forEach(function(side) {
      var textInput  = sid('coverText' + side);
      var fontSelect = sid('coverFont' + side);
      var sizeSelect = sid('coverSize' + side);
      var lhSelect   = sid('coverLineHeight' + side);
      var widthRange = sid('coverWidth' + side);
      var widthVal   = sid('coverWidthVal' + side);

      if (textInput) {
        textInput.addEventListener('focus', function() {
          var isFront = side.charAt(0) === 'A';
          activatePreviewSlide(isFront ? 'front-cover' : 'back-cover');
        });
        textInput.addEventListener('input', function() {
          state.coverText[side].text = textInput.value;
          updateCoverTextPreview(side);
          refreshSiblingPreviews(side);
          updateStepCheckmarks();
        });
      }
      if (fontSelect) fontSelect.addEventListener('change', function() {
        state.coverText[side].font = fontSelect.value;
        preloadFont(fontSelect.value, state.coverText[side].bold, state.coverText[side].italic);
        updateCoverTextPreview(side);
      });
      if (sizeSelect) sizeSelect.addEventListener('change', function() {
        state.coverText[side].size = sizeSelect.value;
        updateCoverTextPreview(side);
      });
      if (lhSelect) lhSelect.addEventListener('change', function() {
        state.coverText[side].lineHeight = lhSelect.value;
        updateCoverTextPreview(side);
      });
      if (widthRange) widthRange.addEventListener('input', function() {
        var w = parseInt(widthRange.value, 10) || 50;
        state.coverText[side].w = w;
        if (widthVal) widthVal.textContent = w + '%';
        updateCoverTextPreview(side);
      });
    });

    initDraggableOverlays();
  }

  /* ==========================================================================
     COLOR PICKERS (ported from main constructor)
     ========================================================================== */
  function syncColorToState(picker, color) {
    var fieldGroup = picker.closest('.vinyl-text-field-group');
    if (fieldGroup) {
      var key = fieldGroup.dataset.fieldKey;
      if (key && state.coverText[key]) { state.coverText[key].color = color; updateCoverTextPreview(key); return; }
    }
    var panel = picker.closest('.vinyl-cover-text-panel');
    if (panel) {
      var side = panel.dataset.coverPanel;
      if (state.coverText[side]) { state.coverText[side].color = color; updateCoverTextPreview(side); }
    }
  }

  function bindColorPickers() {
    root.querySelectorAll('.vinyl-color-picker').forEach(function(picker) {
      var swatches = picker.querySelectorAll('.vinyl-swatch');
      var hexInput = picker.querySelector('.vinyl-hex-input');
      var preview  = picker.querySelector('.vinyl-color-hex__preview');

      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          var color = swatch.dataset.color;
          swatches.forEach(function(s) { s.classList.remove('vinyl-swatch--active'); });
          swatch.classList.add('vinyl-swatch--active');
          if (hexInput) hexInput.value = color;
          if (preview) preview.style.background = color;
          syncColorToState(picker, color);
        });
      });

      if (hexInput) {
        hexInput.addEventListener('input', function() {
          var val = hexInput.value.trim();
          if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
            if (preview) preview.style.background = val;
            swatches.forEach(function(s) { s.classList.toggle('vinyl-swatch--active', s.dataset.color && s.dataset.color.toUpperCase() === val.toUpperCase()); });
            syncColorToState(picker, val);
          }
        });
        hexInput.addEventListener('blur', function() {
          var val = hexInput.value.trim();
          if (!/^#[0-9A-Fa-f]{6}$/.test(val)) {
            hexInput.value = '#FFFFFF';
            if (preview) preview.style.background = '#FFFFFF';
            syncColorToState(picker, '#FFFFFF');
          }
        });
      }
    });
  }

  /* ==========================================================================
     FORMAT TOOLBAR — Bold / Italic / Underline (ported from main)
     ========================================================================== */
  function bindFormatToolbars() {
    root.querySelectorAll('.vinyl-format-toolbar').forEach(function(toolbar) {
      var target = toolbar.dataset.formatTarget || '';
      toolbar.querySelectorAll('.vinyl-format-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var format = btn.dataset.format;
          btn.classList.toggle('vinyl-format-btn--active');
          var isActive = btn.classList.contains('vinyl-format-btn--active');
          var fieldGroup = btn.closest('.vinyl-text-field-group');
          if (fieldGroup) {
            var key = fieldGroup.dataset.fieldKey;
            if (key && state.coverText[key]) {
              state.coverText[key][format] = isActive;
              if (format === 'bold' || format === 'italic') preloadFont(state.coverText[key].font, state.coverText[key].bold, state.coverText[key].italic);
              updateCoverTextPreview(key);
              return;
            }
          }
          if (target.startsWith('cover')) {
            var side = target.replace('cover', '');
            if (state.coverText[side]) {
              state.coverText[side][format] = isActive;
              if (format === 'bold' || format === 'italic') preloadFont(state.coverText[side].font, state.coverText[side].bold, state.coverText[side].italic);
              updateCoverTextPreview(side);
            }
          }
        });
      });
    });
  }

  /* ==========================================================================
     ADD-ONS, QUANTITY, ACCORDION
     ========================================================================== */
  function bindAddons() {
    qAll('.vinyl-addon input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        updateAddonsTotal();
        updateStepCheckmarks();
        var shippingEl = root.querySelector('.shipping_days');
        if (shippingEl) {
          var priorityCb = root.querySelector('.vinyl-addon input[data-value="15"]:checked');
          shippingEl.textContent = priorityCb ? '3-5 days' : (config.processingDays || '7-10 days');
        }
        saveState();
      });
    });
  }

  function bindQuantity() {
    if (!dom.quantityInput) return;
    var controls = dom.quantityInput.closest('.vinyl-quantity__controls');
    var minus = controls && controls.querySelector('[name="minus"]');
    var plus  = controls && controls.querySelector('[name="plus"]');
    if (minus) minus.addEventListener('click', function() {
      var v = parseInt(dom.quantityInput.value, 10) || 1;
      if (v > 1) { dom.quantityInput.value = v - 1; state.quantity = v - 1; updatePriceDisplay(); saveState(); }
    });
    if (plus) plus.addEventListener('click', function() {
      var v = parseInt(dom.quantityInput.value, 10) || 1;
      dom.quantityInput.value = v + 1; state.quantity = v + 1; updatePriceDisplay(); saveState();
    });
    dom.quantityInput.addEventListener('change', function() {
      var val = parseInt(dom.quantityInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      dom.quantityInput.value = val; state.quantity = val; updatePriceDisplay(); saveState();
    });
  }

  function bindAccordion() {
    var steps = dom.accordion ? dom.accordion.querySelectorAll('.vinyl-step') : [];
    steps.forEach(function(step) {
      var header = step.querySelector('.vinyl-step__header');
      if (!header) return;
      header.addEventListener('click', function() {
        var isActive = step.classList.contains('vinyl-step--active');
        steps.forEach(function(s) { s.classList.remove('vinyl-step--active'); });
        if (!isActive) step.classList.add('vinyl-step--active');
      });
    });
    if (steps.length && !steps[0].classList.contains('vinyl-step--active')) steps[0].classList.add('vinyl-step--active');
  }

  /* ==========================================================================
     FORM SUBMISSION
     ========================================================================== */
  function buildFormData() {
    var fd = new FormData();
    var variantInput = dom.form.querySelector('[name="id"]');
    var variantId = variantInput ? variantInput.value : (config.variantId || '');
    var qty = dom.quantityInput ? parseInt(dom.quantityInput.value, 10) || 1 : 1;
    if (!variantId) throw new Error('No product variant found');
    fd.append('id', variantId);
    fd.append('quantity', qty);

    var imageLabels = { 1: 'Front Cover', 2: 'Back Cover' };
    for (var idx = 1; idx <= 2; idx++) {
      var upload = state.uploadedFiles[idx];
      if (!upload) continue;
      var label = imageLabels[idx];
      if (upload.fileUrl && upload.fileUrl.indexOf('://') !== -1 && upload.fileUrl.indexOf('data:') !== 0) {
        fd.append('properties[' + label + ']', upload.fileUrl);
      } else if (upload.blob) {
        fd.append('properties[' + label + ']', upload.blob, upload.name || ('image_' + idx + '.jpg'));
      } else if (upload.previewUrl && upload.previewUrl.indexOf('data:') === 0) {
        fd.append('properties[' + label + ']', upload.previewUrl);
      } else {
        fd.append('properties[' + label + ']', 'Uploaded: ' + (upload.name || 'image'));
      }
    }

    var coverLabels = { A: 'Front Cover Text 1', A2: 'Front Cover Text 2', A3: 'Front Cover Text 3', B: 'Back Cover Text 1', B2: 'Back Cover Text 2', B3: 'Back Cover Text 3', B4: 'Back Cover Text 4' };
    COVER_KEYS.forEach(function(key) {
      var ct = state.coverText[key];
      var domInput = sid('coverText' + key);
      if (domInput && domInput.value && domInput.value.trim()) ct.text = domInput.value.trim();
      if (ct && ct.text) fd.append('properties[' + coverLabels[key] + ']', ct.text);
    });

    var addonDetails = [];
    qAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) {
      var lbl = cb.closest('.vinyl-addon') && cb.closest('.vinyl-addon').querySelector('label');
      var priceVal = cb.dataset.value || '0';
      addonDetails.push({ name: lbl ? lbl.textContent.trim() : 'Add-on', price: priceVal });
    });
    if (addonDetails.length) {
      fd.append('properties[Add-on Services]', addonDetails.map(function(a) { return a.name + ' (+$' + a.price + ')'; }).join(' | '));
      addonDetails.forEach(function(a, i) { fd.append('properties[Service ' + (i + 1) + ']', a.name + ' — $' + a.price); });
    }
    return fd;
  }

  function buildAddonItems() {
    var qty = dom.quantityInput ? parseInt(dom.quantityInput.value, 10) || 1 : 1;
    var items = [];
    qAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) {
      var vid = cb.dataset.variantId || cb.dataset.variant_id;
      if (vid) items.push({ id: parseInt(vid, 10), quantity: qty, properties: { _hidden: 'true' } });
    });
    return items;
  }

  function bindFormSubmit() {
    if (!dom.form) return;
    dom.form.addEventListener('submit', function(ev) {
      ev.preventDefault();
      if (!state.customizationComplete) return;
      var submitButton = dom.form.querySelector('[type="submit"]');
      if (!submitButton) return;
      submitButton.disabled = true;
      submitButton.classList.add('loading');
      var spinner = submitButton.querySelector('.vinyl-spinner');
      if (spinner) spinner.classList.remove('hidden');

      var fd = buildFormData();
      var addonItems = buildAddonItems();

      fetch('/cart/add', { method: 'POST', body: fd })
        .then(function(res) {
          if (!res.ok && res.status >= 400 && res.status < 500) return res.text().then(function() { throw new Error('Could not add to cart'); });
          return res.text();
        })
        .then(function() {
          if (!addonItems.length) return Promise.resolve();
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: addonItems }) }).catch(function() {});
        })
        .then(function() {
          try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {}
          window.location.href = '/cart';
        })
        .catch(function(err) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          alert(err.message || 'Could not add to cart.');
        });
    });
  }

  /* ==========================================================================
     MODALS (walkthrough etc.)
     ========================================================================== */
  function bindModals() {
    qAll('.vinyl-product__help-trigger').forEach(function(tr) {
      tr.addEventListener('click', function() {
        var mid = tr.dataset.modal;
        if (mid) { var m = document.getElementById(mid); if (m) m.style.display = 'flex'; }
      });
    });
    qAll('.vinyl-modal__close').forEach(function(close) {
      close.addEventListener('click', function() { var m = close.closest('.vinyl-modal'); if (m) m.style.display = 'none'; });
    });
  }

  /* ==========================================================================
     Remove Zakeke app injection (hides our ATC, shows "Out of Stock")
     ========================================================================== */
  function removeZakeke() {
    var zBtn = root.querySelector('#zakeke-product-button');
    if (zBtn) {
      var container = zBtn.closest('.zakeke-product-button-container') || zBtn.parentNode;
      if (container) container.remove(); else zBtn.remove();
    }
    root.querySelectorAll('.zakeke-product-button-container').forEach(function(el) { el.remove(); });
    root.querySelectorAll('[name="zakeke-product-id"], [name="zakeke-locale"]').forEach(function(el) { el.remove(); });
    var atcBtn = root.querySelector('.vinyl-btn--atc');
    if (atcBtn) atcBtn.style.removeProperty('display');
  }

  /* ==========================================================================
     INIT
     ========================================================================== */
  function init() {
    if (!dom.accordion) return;
    removeZakeke();
    setTimeout(removeZakeke, 100);
    setTimeout(removeZakeke, 500);
    setTimeout(removeZakeke, 1500);
    setTimeout(removeZakeke, 3000);
    var cartActions = root.querySelector('.vinyl-cart-actions');
    if (cartActions && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function() { removeZakeke(); })
        .observe(cartActions, { childList: true, subtree: true });
    }
    bindPreviewThumbs();
    bindAccordion();
    bindUploaders();
    bindCropModal();
    bindCoverTextUI();
    bindColorPickers();
    bindFormatToolbars();
    applyFontPreviews();
    bindAddons();
    bindQuantity();
    bindFormSubmit();
    bindModals();
    restoreState();
    checkCustomizationStatus();
    updatePriceDisplay();

    document.addEventListener('currency:update', function() {
      if (window._vinylCurrencyUpdating) return;
      updatePriceDisplay();
    });
  }

  function initCustomFontSizeDropdowns() {
    var selects = document.querySelectorAll('.vinyl-fontsize-select');
    selects.forEach(function(sel) {
      if (sel.closest('.vinyl-custom-select')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'vinyl-custom-select';

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'vinyl-custom-select__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      var selectedOpt = sel.options[sel.selectedIndex];
      trigger.textContent = selectedOpt ? selectedOpt.text : '';

      var dropdown = document.createElement('div');
      dropdown.className = 'vinyl-custom-select__dropdown';
      dropdown.setAttribute('role', 'listbox');

      Array.from(sel.options).forEach(function(opt) {
        var item = document.createElement('div');
        item.className = 'vinyl-custom-select__option';
        if (opt.selected) item.classList.add('vinyl-custom-select__option--selected');
        item.setAttribute('role', 'option');
        item.setAttribute('data-value', opt.value);
        item.textContent = opt.text;

        item.addEventListener('click', function(e) {
          e.stopPropagation();
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.textContent = opt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.remove('vinyl-custom-select__option--selected');
          });
          item.classList.add('vinyl-custom-select__option--selected');
          wrapper.classList.remove('vinyl-custom-select--open');
          trigger.setAttribute('aria-expanded', 'false');
        });

        dropdown.appendChild(item);
      });

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = wrapper.classList.contains('vinyl-custom-select--open');

        document.querySelectorAll('.vinyl-custom-select--open').forEach(function(w) {
          w.classList.remove('vinyl-custom-select--open');
          w.querySelector('.vinyl-custom-select__trigger').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          wrapper.classList.add('vinyl-custom-select--open');
          trigger.setAttribute('aria-expanded', 'true');
          var selectedItem = dropdown.querySelector('.vinyl-custom-select__option--selected');
          if (selectedItem) {
            selectedItem.scrollIntoView({ block: 'nearest' });
          }
        }
      });

      sel.parentNode.insertBefore(wrapper, sel);
      wrapper.appendChild(sel);
      wrapper.appendChild(trigger);
      wrapper.appendChild(dropdown);

      var observer = new MutationObserver(function() {
        var curOpt = sel.options[sel.selectedIndex];
        if (curOpt) {
          trigger.textContent = curOpt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.toggle('vinyl-custom-select__option--selected',
              o.getAttribute('data-value') === sel.value);
          });
        }
      });
      observer.observe(sel, { attributes: true, childList: true, subtree: true });

      sel.addEventListener('change', function() {
        var curOpt = sel.options[sel.selectedIndex];
        if (curOpt) {
          trigger.textContent = curOpt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.toggle('vinyl-custom-select__option--selected',
              o.getAttribute('data-value') === sel.value);
          });
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.vinyl-custom-select')) {
        document.querySelectorAll('.vinyl-custom-select--open').forEach(function(w) {
          w.classList.remove('vinyl-custom-select--open');
          w.querySelector('.vinyl-custom-select__trigger').setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  var _origInit = init;
  init = function() {
    _origInit();
    initCustomFontSizeDropdowns();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
